import type { ReactNode } from 'react';

import { useId } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { Label } from '@shared/components/ui/label';
import { Switch } from '@shared/components/ui/switch';

type Props = {
  name: string;
  label: ReactNode;
  helperText?: ReactNode;
};

export const RHFSwitch = ({ name, label, helperText }: Props) => {
  const { control } = useFormContext();
  const id = useId();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-3">
            <Switch checked={!!field.value} id={id} onCheckedChange={field.onChange} />
            <Label className="cursor-pointer" htmlFor={id}>
              {label}
            </Label>
          </div>
          {(error?.message || helperText) && (
            <p className={error ? 'text-xs text-destructive' : 'text-xs text-muted-foreground'}>
              {error?.message ?? helperText}
            </p>
          )}
        </div>
      )}
    />
  );
};
